import querystring from 'query-string-for-all';
const extractLimitOffset = (page) => {
    let result = { limit: null, offset: null };
    if (page) {
        const splittedNext = page.split('?');
        if (splittedNext.length > 1) {
            const { limit, offset } = querystring.parse(splittedNext[1]);
            if (typeof limit === 'string' && typeof offset === 'string') {
                result = { limit, offset };
            }
        }
    }
    return result;
};
/**
 * Extract a page number based on offset and limit return false if this page number could not be computed
 * @param url An url containing "limit" and "offset" query params
 */
export const computeNextPage = (url) => {
    let nextPage = false;
    const { limit, offset } = extractLimitOffset(url);
    if (limit && offset) {
        nextPage = +offset / +limit;
    }
    return nextPage;
};
export const getPageQueryParams = (pageNumber, limit) => ({
    offset: pageNumber * limit,
    limit
});
